angular.module('app.directives.schedule').directive('youtubeLiveSimulcastSettings', () => {
  return {
    restrict: 'E',
    scope: {
      vm: '=',
      config: '=',
    },
    template: require('./youtube-live-simulcast-settings.html'),
  };
});



// WEBPACK FOOTER //
// ./app/directives/schedule/youtube-live-simulcast-settings.js